export const BATTERY_THRESHOLD_SWITCH_ID = 'ds-power-battery-threshold';
